module.exports = __webpack_public_path__ + "static/media/skassa.3f2be764.jpg";